(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('checkboxPills', checkboxPills);

    checkboxPills.$inject = ['$timeout'];

    function checkboxPills($timeout) {
        return {
            restrict: 'E',
            scope: {
                items: '<',
                selectedItems: '=?',
                disabled: '=?',
                onChange: '&?'
            },
            templateUrl: '/app/common/checkbox-pills.html',
            link: function (scope) {
                // Initialize selected items if not provided
                if (!scope.selectedItems) {
                    scope.selectedItems = [];
                }

                // Toggle selection
                scope.toggleSelection = function (item) {
                    // Check if disabled globally or item is disabled
                    if (scope.disabled || item.disabled) return;

                    // Handle both Value property (0/1) and direct selection array
                    if (item.hasOwnProperty('Value')) {
                        item.Value = item.Value ? 0 : 1;
                    } else {
                        var idx = scope.selectedItems.indexOf(item.Id);
                        if (idx > -1) {
                            scope.selectedItems.splice(idx, 1);
                        } else {
                            scope.selectedItems.push(item.Id);
                        }
                    }

                    // Trigger onChange callback after digest cycle completes
                    if (scope.onChange) {
                        $timeout(function () {
                            scope.onChange({ item: item });
                        });
                    }
                };

                // Check if item or container is disabled
                scope.isDisabled = function (item) {
                    return scope.disabled || item.disabled;
                };

                // Check if item is selected
                scope.isSelected = function (item) {
                    if (item.hasOwnProperty('Value')) {
                        return item.Value === 1 || item.Value === true;
                    }
                    return scope.selectedItems.indexOf(item.Id) > -1;
                };

                // Check if item should be shown
                scope.shouldShow = function (item) {
                    // Always show items - pills should remain visible when unselected
                    return true;
                };
            }
        };
    }
})();
